export default __webpack_public_path__ + "static/media/663d4fb46e78015477a20554401f8fb5.26daa55a.png";